/**
 * Contolla se il device è mobile, false altrimenti
*/
export const isMobileDevice = () => (typeof window !== 'undefined' && typeof window.orientation !== 'undefined') || 
    (typeof navigator !== 'undefined' && navigator.userAgent.indexOf('IEMobile') !== -1);

/**
 * Verifica se l'url è un video
 * @param {string} url
 */
export const getIsVideoFromUrl = (url = '') => url.includes('.mp4') || url.includes('.mlv');
